/**
 * Replaces the emoji glyphs in the "Our Story" page cards with inline SVG
 * line illustrations.
 *
 * Why: the markup lives in Shopify page content, not in a theme file, so the
 * emoji cannot be edited out at source. Two of them were also rendering as
 * tofu boxes - U+1FAA1 (sewing needle) is Emoji 13.0 and is missing from the
 * fonts in use, so the "Craft" and "100%" cards showed an empty rectangle.
 *
 * Mapping is keyed on the emoji itself rather than on nth-child, so it keeps
 * working if the cards are reordered or added to. Icons are stroke-based and
 * use currentColor, so they follow the palette set in custom-overrides.css.
 */
(function () {
  'use strict';

  var svg = function (paths) {
    return (
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" ' +
      'stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">' +
      paths +
      '</svg>'
    );
  };

  var ICONS = {
    // Needle and thread - craftsmanship
    '\u{1FAA1}': svg(
      '<circle cx="19.4" cy="3.6" r="1.8"/>' +
        '<path d="M18.1 4.9 9.3 13.7"/>' +
        '<path d="M9.3 13.7 7 18.6l4.9-2.3z"/>' +
        '<path d="M17.7 2.3c-2.6-1.1-5.5-.1-6.4 2-.8 1.9.8 3.5 2.3 2.9 1.3-.5 1.2-2.3-.3-2.5"/>'
    ),
    // Shield with a check - trust (COD, returns, real people answering)
    '\u{1F91D}': svg(
      '<path d="M12 2.9 19.6 6v5.9c0 4.2-3.1 7.3-7.6 8.9-4.5-1.6-7.6-4.7-7.6-8.9V6z"/>' +
        '<path d="m8.9 11.9 2.2 2.2 4.1-4.3"/>'
    ),
    // Leaf and stem - intention
    '\u{1F33F}': svg(
      '<path d="M10.6 20.8c0-5.4 2.2-9.5 6.5-12.3"/>' +
        '<path d="M18.9 6.1c.6 4.8-1.8 8.3-6.2 8.7-1.5.1-2.7-.6-3.1-2-.5-1.7.7-3.4 2.6-4.3 2.2-1.1 4.6-1.6 6.7-2.4z"/>'
    ),
    // Star - average rating
    '\u{2B50}': svg('<path d="m12 3.3 2.6 5.4 5.9.9-4.3 4.2 1 5.9-5.2-2.8-5.2 2.8 1-5.9-4.3-4.2 5.9-.9z"/>'),
    // Delivery truck - pan-India shipping
    '\u{1F69A}': svg(
      '<path d="M2.8 6.4h10v9h-10z"/>' +
        '<path d="M12.8 9.6h3.9l2.7 3v2.8h-6.6z"/>' +
        '<circle cx="6.8" cy="17.4" r="1.8"/>' +
        '<circle cx="16.4" cy="17.4" r="1.8"/>' +
        '<path d="M2.8 15.4H5M8.6 15.4h4.2"/>'
    ),
    // Classical facade - legacy / family business
    '\u{1F3DB}': svg(
      '<path d="M3.4 9.6 12 4.6l8.6 5"/>' +
        '<path d="M5.9 9.9v7.2M9.9 9.9v7.2M14.1 9.9v7.2M18.1 9.9v7.2"/>' +
        '<path d="M3.6 17.4h16.8M2.9 20.3h18.2"/>'
    ),
  };

  // Strip emoji variation selectors / ZWJ so "\u{1F3DB}️" matches "\u{1F3DB}".
  function normalise(text) {
    return text.replace(/[︎️‍\s]/g, '');
  }

  function render() {
    var nodes = document.querySelectorAll('.value-icon, .cs-icon');
    if (!nodes.length) return; // not this page - do nothing

    nodes.forEach(function (el) {
      if (el.dataset.illustrated) return;
      var markup = ICONS[normalise(el.textContent)];
      if (!markup) return; // unknown glyph - leave it exactly as authored
      el.dataset.illustrated = 'true';
      el.innerHTML = markup;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
})();
